document.addEventListener("DOMContentLoaded", function () {
    const generatePdfButton = document.getElementById('generate-pdf');
  
    if (generatePdfButton) {
      generatePdfButton.addEventListener('click', function () {
        const { jsPDF } = window.jspdf;
  
        function generateQRCode(text) {
          return new Promise((resolve, reject) => {
            try {
              const canvas = document.createElement('canvas');
              QRCode.toCanvas(canvas, text, { width: 70 }, function (error) {
                if (error) {
                  reject(error);
                } else {
                  resolve(canvas.toDataURL("image/png"));
                }
              });
            } catch (e) {
              reject(e);
            }
          });
        }
  
        const marginX = 20;
        const marginY = 5;
  
        function getLogoHeight(logoSrc, logoWidth, callback) {
          const img = new Image();
          img.onload = function () {
            const aspectRatio = img.width / img.height; 
            const logoHeight = logoWidth / aspectRatio; 
            callback(logoHeight); 
          };
          img.onerror = function () {
            console.error('Logo konnte nicht geladen werden.');
          };
          img.src = logoSrc;
        }
  
        async function generatePDF() {
          const logoSrc = "https://cdn.shopify.com/s/files/1/0577/6519/9970/files/skapetze-logo2.png?v=1730620635";
  
          const imageElement = document.querySelector('.media-viewer__item.is-current-variant img');
          const imgSrc = imageElement ? imageElement.src : null;
          const productVendorInfoElement = document.querySelector('.product-info__block.product-info__block--sm.product-vendor-sku.text-sm');
          const productVendorInfo = productVendorInfoElement ? productVendorInfoElement.innerText.trim() : '';
          const titleContent = document.querySelector('.product-title').innerText.trim();
          const priceElement = document.querySelector('.price__default.flex');
          const priceContent = priceElement ? priceElement.innerText.trim() : '';
          const currentURL = window.location.href;
  
          const doc = new jsPDF();
  
          const logoWidth = 30; 
          getLogoHeight(logoSrc, logoWidth, async function (logoHeight) {
            doc.addImage(logoSrc, 'PNG', marginX, marginY, logoWidth, logoHeight);
  
            const websiteText = "www.skapetze.com";
            const websiteTextX = doc.internal.pageSize.width - marginX - doc.getTextWidth(websiteText) + 20;
            doc.setFontSize(10);
            doc.text(websiteText, websiteTextX, marginY + logoHeight / 2);
  
            const imageWidth = 80;
            const imageHeight = 80;
            const imageX = marginX;
            const imageY = marginY + logoHeight + 10;
  
            if (imgSrc) {
              doc.addImage(imgSrc, 'JPEG', imageX, imageY, imageWidth, imageHeight);
            }
  
            const textStartX = marginX + imageWidth + 10;
            let textStartY = imageY + 2;
  
            doc.setFontSize(10);
            doc.text(productVendorInfo, textStartX, textStartY);
            textStartY += 10;
  
            doc.setFontSize(16); 
            const wrappedTitle = doc.splitTextToSize(titleContent, doc.internal.pageSize.width - 2 * marginX - imageWidth - 20);
            doc.text(wrappedTitle, textStartX, textStartY);
  
            textStartY += wrappedTitle.length * 10;
  
            const priceLines = priceContent.split('\n');
            doc.setFontSize(15);
            doc.setTextColor(255, 89, 38); 
            doc.setFont('helvetica', 'bold');
            doc.text(priceLines[0], textStartX, textStartY);
  
            if (priceLines[1]) {
              textStartY += 5;
              doc.setFontSize(10);
              doc.setFont('helvetica', 'normal');
              doc.setTextColor(0, 0, 0); 
              doc.text(priceLines[1], textStartX, textStartY);
            }
  
            try {
              const qrCodeSrc = await generateQRCode(currentURL); 
              const qrCodeSize = 30; 
              const qrCodeX = textStartX - 2; 
              textStartY += 15;
              doc.addImage(qrCodeSrc, 'PNG', qrCodeX, textStartY, qrCodeSize, qrCodeSize);
              textStartY += qrCodeSize + 10; 
            } catch (error) {
              console.error("QR Code generation failed:", error);
            }
  
            const propertiesStartY = textStartY + 10;
            let currentY = propertiesStartY;
  
            const propertySections = document.querySelectorAll('.properties_block .properties'); 
            propertySections.forEach((section, sectionIndex) => {
              const propertyTitleElement = section.querySelector('.property-title');
              if (propertyTitleElement) {
                const propertyTitleText = propertyTitleElement.innerText.trim();
                doc.setFontSize(14);
                doc.setFont('helvetica', 'bold');
                doc.text(propertyTitleText, marginX, currentY);
                currentY += 10;
              }
  
              const propertyItems = section.querySelectorAll('.flex-wrap');
              propertyItems.forEach(item => {
                const titleElement = item.querySelector('.title');
                const propertyElement = item.querySelector('.property');
  
                if (titleElement && propertyElement) {
                  const titleText = titleElement.innerText.trim();
                  const propertyText = propertyElement.innerText.trim();
                  const availableWidth = doc.internal.pageSize.width - 2 * marginX;
                  const titleTextX = marginX;
                  const propertyTextX = marginX + availableWidth - doc.getTextWidth(propertyText);
  
                  doc.setFontSize(12);
                  doc.setFont('helvetica', 'normal');
                  doc.text(titleText, titleTextX, currentY);
                  doc.text(propertyText, propertyTextX, currentY);
                  currentY += 7;
   
                  if (currentY + 10 > doc.internal.pageSize.height - marginY) {
                    doc.addPage();
                    currentY = marginY + 10;
                  }
                }
              });
            });
  
            const fileName = `${titleContent}.pdf`.replace(/[\/:*?"<>|]/g, ''); 
            doc.save(fileName);
          });
        }
  
        generatePDF();
      });
    }
  });
  